import { action, computed, observable, reaction, makeObservable } from 'mobx';
import { ControleGabinete, Minuta, Processo } from '../modelo';
import ControleGabineteStore from './ControleGabineteStore';
import EscaninhoStore from './EscaninhoStore';

class MovimentacaoInternaStore {
    openModal = false;
    servidorAtribuido = '-1';
    proximoCard = -2;
    modalAberto = false;
    labelBotao = 'Enviar Para Pauta';
    desabilitarBotao = false;
    openModalProximaTarefa = false;
    observacao = '';

    minuta?: Minuta;
    processo?: Processo;

    modoLote = false;

    reactionControleGabAtribuido!: ReturnType<typeof reaction>;

    constructor() {
        makeObservable(this, {
            openModal: observable,
            servidorAtribuido: observable,
            proximoCard: observable,
            modalAberto: observable,
            labelBotao: observable,
            desabilitarBotao: observable,
            openModalProximaTarefa: observable,
            observacao: observable,
            minuta: observable,
            processo: observable,
            modoLote: observable,
            ativarBotao: action,
            desativarBotao: action,
            abrirModal: action,
            fecharModal: action,
            handleDistribuirProcesso: action,
            controleProximoCard: computed
        });

        this.reactionControleGabAtribuido = reaction(
            () => EscaninhoStore.processosSelecionados[0]?.controleGabinete?.numero,
            (controleGabAtribuido) => {
                if (controleGabAtribuido && this.modoLote) {
                    this.proximoCard = controleGabAtribuido;
                }
            }
        );
    }

    ativarBotao(label: string) {
        this.labelBotao = label;
        this.desabilitarBotao = false;
    }

    desativarBotao(label: string) {
        this.labelBotao = label;
        this.desabilitarBotao = false;
    }

    abrirModal() {
        this.modalAberto = true;

        this.modoLote = EscaninhoStore.processosSelecionados.length > 1;

        // LIMPA PROCESSO SE FOR LOTE
        if (this.modoLote) {
            this.processo = undefined;
        }
    }

    fecharModal() {
        this.minuta = undefined;
        this.processo = undefined;
        this.modalAberto = false;
        this.modoLote = false; // RESET
    }

    handleDistribuirProcesso = (
        processo?: Processo,
        minuta?: Minuta,
    ) => {

        if (minuta) {
            this.minuta = minuta;
            this.modoLote = false;
        }
        else if (processo) {
            this.processo = processo;
            this.modoLote = false; // FORÇA MANUAL
        }
        else {
            // LOTE
            this.processo = undefined;
            this.modoLote = true;
        }

        this.modalAberto = true;
    };

    getControleGabinete(processo: Processo): ControleGabinete {
        return processo.controleGabinete
            ? processo.controleGabinete
            : ControleGabineteStore.listaDeControles[
                ControleGabineteStore.listaDeControles.length - 1
              ];
    }

    getControleGabinetePorNumero(numeroControle: number): ControleGabinete {
        return ControleGabineteStore.listaDeControles.find(
            controle => controle.numero === numeroControle
        );
    }

    get controleProximoCard() {
        return this.proximoCard && ControleGabineteStore.buscarPorNumero(this.proximoCard);
    }
}

export default new MovimentacaoInternaStore();
